import type { ComponentProps } from 'react';
import { ArrowLeft01Icon, ArrowRight01Icon } from '@hugeicons/core-free-icons';

import { Button } from './Button';
import { HugeIcon } from './HugeIcon';
import { cn } from '../../lib/cn';

function Pagination({ className, ...props }: ComponentProps<'nav'>) {
  return (
    <nav
      aria-label="Table pagination"
      className={cn('flex w-full items-center justify-between gap-3', className)}
      role="navigation"
      {...props}
    />
  );
}

function PaginationStatus({ className, ...props }: ComponentProps<'p'>) {
  return <p className={cn('text-xs font-medium text-muted-foreground', className)} {...props} />;
}

function PaginationControls({ className, ...props }: ComponentProps<'div'>) {
  return <div className={cn('flex items-center gap-2', className)} {...props} />;
}

function PaginationPrevious(props: ComponentProps<typeof Button>) {
  return (
    <Button aria-label="Go to previous page" size="sm" type="button" variant="outline" {...props}>
      <HugeIcon icon={ArrowLeft01Icon} size={14} />
      <span className="hidden sm:inline">Previous</span>
    </Button>
  );
}

function PaginationNext(props: ComponentProps<typeof Button>) {
  return (
    <Button aria-label="Go to next page" size="sm" type="button" variant="outline" {...props}>
      <span className="hidden sm:inline">Next</span>
      <HugeIcon icon={ArrowRight01Icon} size={14} />
    </Button>
  );
}

export {
  Pagination,
  PaginationControls,
  PaginationNext,
  PaginationPrevious,
  PaginationStatus,
};
